import { EditFilter } from "@/components/campaign/configuration/EditFilter";
import { getFilterGroupById } from "@/data/filters/config";
import { Configuration } from "@/types/campaign";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { SetStateAction } from "jotai";
import { useCallback, useMemo } from "react";
import z from "zod";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/define/$category/$filter",
)({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      quality: z.number().optional(),
    }),
  ),
  loaderDeps: ({ search }) => ({ quality: search.quality }),
  loader: ({ params, deps }) => {
    const filterGroup = getFilterGroupById(params.filter);

    return {
      filterGroup,
      ...(deps.quality !== undefined
        ? {
            isBreadcrumbRoot: true,
            crumb: "Rediger filter",
          }
        : {
            crumb: filterGroup?.group.title,
          }),
    };
  },
});

function RouteComponent() {
  const { useEditCampaign } = Route.useRouteContext();
  const { filter } = Route.useParams();
  const navigate = Route.useNavigate();

  const { editCampaign, setEditCampaign } = useEditCampaign();

  const configuration = useMemo(
    () => editCampaign.configurations.find((c) => c.quality === 1),
    [editCampaign],
  );

  const setConfiguration = useCallback(
    (action: SetStateAction<Configuration>) => {
      setEditCampaign((prev) => ({
        ...prev,
        configurations: prev.configurations.map((c) => {
          if (c.quality === 1)
            return typeof action === "function" ? action(c) : action;
          return c;
        }),
      }));
    },
    [setEditCampaign],
  );

  if (!configuration) throw null;

  return (
    <div>
      <EditFilter
        configuration={configuration}
        setConfiguration={setConfiguration}
        isNewCampaign
        onUpdated={() => {
          navigate({ to: "/campaigns/$id/define" });
        }}
        backLinkOptions={{
          from: Route.fullPath,
          to: "/campaigns/$id/define/$category",
        }}
        filterGroupId={filter}
        hideCancelButton={false}
        hasBorder={false}
      />
    </div>
  );
}
